
FWS.Display = {

  getHeaderHeight() {
    const header = document.querySelector('header')
    return header?.clientHeight || 0
  },

  setHeaderSize() {
    document.body.style.paddingTop = `${FWS.Display.getHeaderHeight()}px`
  },

  getDateDiff(a, b) {

    const aTime = a.getTime()
    const bTime = b.getTime()
    let delta = Math.abs(aTime - bTime) / 1000;

    const days = Math.floor(delta / 86400);
    delta -= days * 86400;
    
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    
    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    
    const seconds = Math.floor(delta % 60)

    return {
      days,
      hours,
      minutes,
      seconds
    }
  },

  smartImage: (() => {
    const shopifySizeConfigRe = /_\d*x\d*\./
    return (url, opts = {}) => {
      if (!url) {
        return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif'
      }
      const { width, height } = opts;
      if (url.includes('cdn.shopify.com')) {
        if (shopifySizeConfigRe.test(url)) {
          return url
        } else {
          return url.replace(/(\.jpe?g)/, `_${width}x${height || ''}$1`)
        }
      } else if (url.includes('freshwatersystems.com/cdn')) {
        const [ base, query ] = url.split('?')
        const existingParams = query ? FWS.Util.queryToObject(query) : {}
        if (width) existingParams.width = width
        if (height) existingParams.height = height
        return `${base}?${FWS.Util.objectToQuery(existingParams)}`
      } else {
        return url
      }
    }
  })(),

  formatMoney(price) {
    if (price == 0) return ''

    if (typeof price === 'string') {
      if (price.includes('.')) {
        const last = price.split('.')[1]
        return last && last.length === 2 ? `$${price}` : `$${price}0`;
      } else {
        return `$${price}.00`
      }
    } else if (typeof price === 'number') {
      return FWS.Display.formatMoney((Math.round(price * 100) / 100).toString())
    }
    return price
  },

  getUrlParam(key, _default="") {
    const params = FWS.Util.queryToObject(window.location.search.slice(1))
    return params[key] || _default
  },

  setUrlParams(obj, opts={}) {
    const current = new URL(window.location.href)
    for (const pair of Object.entries(obj)) {
      current.searchParams.set(pair[0], pair[1])
    }
    window.history[opts.replaceState ? 'replaceState' : 'pushState'](null, null, current.toString())
  }
}

